import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Gym",
  "description": "",
  "published": "2007-09-03T00:00:00.000Z",
  "redirect_from": ["/blog/gym/swizec/160"],
  "categories": "life",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Today I finally managed going to the gym after almost a week of not being able to attend my daily sessions due to insane work hours. Since I've begun going this was the longest period of not going and it was quite an odd feeling. I felt weak and powerless, but at the same time didn't get as tired as I usually do, which, in a way, is good, but maybe it just shows that I was slacking off lest I hurt myself.`}</p>
    <p>{`I did almost manage to hurt myself when I was doing benchpresses where the left side didn't quite go into the resting position, but I still laxed my arms. Luckily the bar was long enough so as to hit the ground before breaking my face. If I wasn't in so much pain from lifting that thing I'd probably get very very frightened by this event.`}</p>
    <p>{`Mentioned insane work hours didn't I? There's this project at work that needs immediate finishing, we only got it a week or so ago, and it required that I worked 12 hours a day on average for a few days including the weekend. If I was a proper employee this wouldn't be too bad, but for cthulhu's sake, I'm technically doing this as a bloody part time job!`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      